module.exports = __webpack_public_path__ + "img/pic-list3.77a7d2e8.jpg";